import { type Session, UserRole } from '../../types/session';

export type SessionState = {
  session?: Session;
  clientUuid: string | null;
  isTimer: boolean;
  isSuperAdmin: boolean;
};

export type SessionStateAction =
  | { type: 'setSession'; payload: Session }
  | { type: 'setClientUuid'; payload: string | null };

const sessionReducer = (state: SessionState, action: SessionStateAction): SessionState => {
  switch (action.type) {
    case 'setSession':
      return {
        ...state,
        session: { ...action.payload },
        isTimer: action.payload.roles?.includes(UserRole.ADMIN) || false,
        isSuperAdmin: action.payload.roles?.includes(UserRole.SUPER_ADMIN) || false,
      };
    case 'setClientUuid':
      return {
        ...state,
        clientUuid: action.payload,
      };
    default:
      return state;
  }
};

export default sessionReducer;
